import { create } from 'zustand'

interface User {
  id: number
  name: string
  email: string
  nickname: string | null
  avatar: string | null
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  hasCompletedOnboarding: boolean
  setAuth: (token: string, user: User) => void
  clearAuth: () => void
  checkAuth: () => void
  setOnboardingComplete: () => void
}

// Inicializar estado a partir do localStorage para evitar flash de logout no reload
const getInitialState = () => {
  const token = localStorage.getItem('sigma_token')
  const userStr = localStorage.getItem('sigma_user')
  const hasCompletedOnboarding = localStorage.getItem('sigma_onboarding_complete') === 'true'

  if (token && userStr) {
    try {
      const user = JSON.parse(userStr)
      return { token, user, isAuthenticated: true, hasCompletedOnboarding }
    } catch {
      return { token: null, user: null, isAuthenticated: false, hasCompletedOnboarding: false }
    }
  }
  return { token: null, user: null, isAuthenticated: false, hasCompletedOnboarding: false }
}

const initialState = getInitialState()

export const useAuthStore = create<AuthState>((set) => ({
  user: initialState.user,
  token: initialState.token,
  isAuthenticated: initialState.isAuthenticated,
  hasCompletedOnboarding: initialState.hasCompletedOnboarding,

  setAuth: (token, user) => {
    localStorage.setItem('sigma_token', token)
    localStorage.setItem('sigma_user', JSON.stringify(user))
    set({ token, user, isAuthenticated: true })
  },

  clearAuth: () => {
    localStorage.removeItem('sigma_token')
    localStorage.removeItem('sigma_user')
    localStorage.removeItem('sigma_onboarding_complete')
    set({ token: null, user: null, isAuthenticated: false, hasCompletedOnboarding: false })
  },

  checkAuth: () => {
    const token = localStorage.getItem('sigma_token')
    const userStr = localStorage.getItem('sigma_user')
    const hasCompletedOnboarding = localStorage.getItem('sigma_onboarding_complete') === 'true'

    if (token && userStr) {
      try {
        const user = JSON.parse(userStr)
        set({ token, user, isAuthenticated: true, hasCompletedOnboarding })
      } catch {
        set({ token: null, user: null, isAuthenticated: false, hasCompletedOnboarding: false })
      }
    } else {
      set({ token: null, user: null, isAuthenticated: false, hasCompletedOnboarding: false })
    }
  },

  setOnboardingComplete: () => {
    localStorage.setItem('sigma_onboarding_complete', 'true')
    set({ hasCompletedOnboarding: true })
  },
}))
